export default __webpack_public_path__ + "static/media/outdoorBackView.676f7ebc.jpg";